import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100%",
        p: { xs: 2, sm: 3 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Typography
        aria-hidden="true"
        sx={{
          color: "rgba(240,236,226,0.12)",
          fontSize: { xs: "5rem", sm: "8rem" },
          fontWeight: 800,
          lineHeight: 1,
          letterSpacing: "-0.08em",
        }}
      >
        404
      </Typography>
      <Typography variant="h6" sx={{ color: "primary.main", mt: 1 }}>
        POSITION NOT FOUND
      </Typography>
      <Typography variant="body2" sx={{ color: "text.secondary", mt: 1, mb: 3 }}>
        This square isn&apos;t on the board.
      </Typography>
      <Button variant="outlined" onClick={() => void navigate("/")}>
        RETURN HOME
      </Button>
    </Box>
  );
};
